import 'bootstrap/js/dist/collapse';

class LifeSession {
  constructor() {
    document.addEventListener("turbo:load", this.init.bind(this));
  }

  copyPasscode() {
    const copyBtn = document.getElementById("copyPasscode");
    const text = document.getElementById("passcodeField");

    copyBtn?.addEventListener("click", e => {
      text.select();
      text.setSelectionRange(0, 99999); /* For mobile devices */
      document.execCommand("copy");
      e.target.innerText = "COPIED PASSCODE";
      text.classList.add("passcode-copied-field");
    });
  }

  copyEmail() {
    const copyEmailBtn = document.querySelectorAll(".copyEmail");

    const removeCopyActive = () => {
      copyEmailBtn.forEach(btn => btn.classList.remove("email-copied-field"));
    }

    copyEmailBtn.forEach(btn => {
      btn.addEventListener("click", () => {
        btn.nextElementSibling.select();
        btn.nextElementSibling.setSelectionRange(0, 99999); /* For mobile devices */
        document.execCommand("copy");
        removeCopyActive();
        btn.classList.add("email-copied-field");
      });
    });
  }

  copyEmails() {
    const btn = document.getElementById("copyEmails");

    if (btn) {
      btn.addEventListener("click", () => {
        const emailsInput = document.querySelector(".attendee-emails-hidden")
        emailsInput.select();
        emailsInput.setSelectionRange(0, 99999); /* For mobile devices */
        document.execCommand("copy");
      });
    }
  }

  init() {
    this.copyPasscode();
    this.copyEmail();
    this.copyEmails();
  }
}

new LifeSession();
